import { THREAD_MAIN_CONTENT_MIN_WIDTH, THREAD_SIDEBAR_MIN_WIDTH } from "./threadSidebarWidth";

export const PROJECT_FILES_SIDEBAR_STORAGE_KEY = "praxa:project-files-sidebar-open";
export const PROJECT_FILES_SIDEBAR_WIDTH_STORAGE_KEY = "praxa:project-files-sidebar-width";
export const PROJECT_FILES_SIDEBAR_DEFAULT_WIDTH = 280;
export const PROJECT_FILES_SIDEBAR_MIN_WIDTH = 224;
export const PROJECT_FILES_SIDEBAR_MAX_WIDTH = 440;
export const PROJECT_FILES_SIDEBAR_KEYBOARD_STEP = 16;
export const PROJECT_FILES_SIDEBAR_MIN_VIEWPORT_WIDTH =
  THREAD_SIDEBAR_MIN_WIDTH + PROJECT_FILES_SIDEBAR_MIN_WIDTH + THREAD_MAIN_CONTENT_MIN_WIDTH;

export function isProjectFilesSidebarLayoutAvailable(viewportWidth: number): boolean {
  return viewportWidth >= PROJECT_FILES_SIDEBAR_MIN_VIEWPORT_WIDTH;
}

export interface ProjectFilesSidebarProjectIdentity {
  readonly environmentId: string;
  readonly id: string;
}

export function projectFilesSidebarProjectKey(project: ProjectFilesSidebarProjectIdentity): string {
  return `${project.environmentId}\u0000${project.id}`;
}

export function resolveProjectFilesSidebarProject<
  TProject extends ProjectFilesSidebarProjectIdentity,
>(
  projects: readonly TProject[],
  selectedProjectKey: string | null,
  activeProjectKey: string | null,
): TProject | null {
  const selectedProject =
    selectedProjectKey === null
      ? null
      : (projects.find(
          (project) => projectFilesSidebarProjectKey(project) === selectedProjectKey,
        ) ?? null);
  if (selectedProject !== null) {
    return selectedProject;
  }

  const activeProject =
    activeProjectKey === null
      ? null
      : (projects.find((project) => projectFilesSidebarProjectKey(project) === activeProjectKey) ??
        null);
  return activeProject ?? projects[0] ?? null;
}
